<template>
    <div class="tour-btn-container fashion">
        <shake-animate>
            <template v-slot="shakeStyle">
                <span
                    class="btn-item save"
                    @click="onFavoriteClick"
                    v-if="info.listingStatus != 'Sold'"
                    :class="[
                        hasFavor ? 'active' : '',
                        !hasFavor && shakeStyle.animate
                    ]"
                >
                    <i class="iconfont icon-heart-fill"></i>
                    <span class="btn-text">{{
                        $t('md-detail-info.save')
                    }}</span>
                </span>
            </template>
        </shake-animate>
        <!-- tour button  -->
        <span
            v-for="tour in tourBtnList"
            :key="[tour.text, tour.link].join('_')"
            class="btn-item"
            :class="tour.text"
        >
            <a
                href="javascript:;"
                @click="handleTour($event, tour)"
                rel="noopener noreferrer"
            >
                <i class="iconfont" :class="tour.icon"></i>
                <span class="btn-text">{{ tour.text }}</span>
            </a>
        </span>
    </div>
</template>

<script>
import TourBtnMediaMixin from '../../tourBtnMediaPopMixin.js';
import shakeAnimate from '../../shake-animate.vue';

export default {
    mixins: [TourBtnMediaMixin],
    inject: ['onFavoriteClick'],
    data: function() {
        return {};
    },
    components: {
        shakeAnimate
    }
};
</script>
<style lang="scss">
.tour-btn-container.fashion {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    justify-content: flex-end;
    .btn-item {
        text-align: center;
        cursor: pointer;
        margin-right: 10px;
        color: var(--color-theme);
        width: 60px;
        border-radius: 2px;
        padding: 20px 0;

        &.save {
            color: #adb9d1;
            .icon-heart-fill {
                font-size: 18px;
                &:before {
                    position: relative;
                }
            }
            border: solid 1px #adb9d1;
            &.active,
            &:hover {
                .icon-heart-fill,.btn-text{
                color: #ed4c4c;
            }
            }
        }
        &.Virtual {
            color: #29cb97;
            border: solid 1px #29cb97;
        }
        &.Video {
            color: #4c84ff;
            border: solid 1px #4c84ff;
        }
        .iconfont {
            font-size: 20px;
            display: block;
            margin-bottom: 10px;
        }
        .btn-text {
            font-size: 14px;
        }
        &:last-child {
            margin-right: 0;
        }
    }
}
@media (max-width: 600px) {
    .tour-btn-container.fashion {
        display: flex;
        margin-top: 15px;
        justify-content: left;
        .btn-item {
            text-align: center;
            cursor: pointer;
            margin-right: 15px;
            width: 50%;
            border-radius: 2px;
            padding: 5px 0px;
            &.save {
                display: none;
            }
            &.Virtual {
                color: #29cb97;
                border: solid 1px #29cb97;
            }
            &.Video {
                color: #4c84ff;
                border: solid 1px #4c84ff;
            }
            > a {
                display: flex;
                justify-content: center;
                align-items: center;
            }
            .iconfont {
                font-size: 18px;
            }
            .btn-text {
                padding-left: 8px;
                font-size: 12px;
            }
            &:last-child {
                margin-right: 0;
            }
        }
    }
}
</style>
